export const CHANGE_LIGHT_THEME_ACTION = "CHANGE_LIGHT_THEME_ACTION";
export const CHANGE_DARK_THEME_ACTION = "CHANGE_DARK_THEME_ACTION";
export const NEXT_THEME_ACTION = "NEXT_THEME_ACTION";

export type ThemeAction =
  | typeof CHANGE_LIGHT_THEME_ACTION
  | typeof CHANGE_DARK_THEME_ACTION
  | typeof NEXT_THEME_ACTION;
